import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Provider } from '../../generated'
import authSlice from '../auth/slice'

interface ProvidersState {
  providerId: number | null
  providers: Provider[]
}

const initialState: ProvidersState = {
  providerId: null,
  providers: [],
}

const providersSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    setProviders: (
      state,
      action: PayloadAction<Pick<ProvidersState, 'providers'>>,
    ) => {
      const { providers } = action.payload

      if (!providers.length) {
        state.providerId = null
      }

      if (
        !state.providerId ||
        !providers?.find((p) => p.id === state.providerId)
      ) {
        state.providerId = providers[0]?.id
      }

      state.providers = providers
    },
    setSelectedProvider: (
      state,
      action: PayloadAction<{ providerId: number }>,
    ) => {
      const { providerId } = action.payload
      state.providerId = providerId
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authSlice.actions.signOut, (state) => {
      return initialState
    })
  },
})

export default providersSlice
